window.getThemePreference = (key = "theme-preference")=>{
    const themePreference = localStorage.getItem(key);
    if (typeof themePreference === "string") return themePreference;
    else return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};
window.reflectThemeChange = ()=>{
    document.documentElement.setAttribute("data-theme", getThemePreference());
};
// Set the `data-theme` attribute early to prevent page flashes
reflectThemeChange();

//# sourceMappingURL=index.2519b184.js.map
